import React from 'react';
import { Box } from '@material-ui/core';
import PayoutManagement from '../../components/admin/affiliate/PayoutManagement';

const AdminPayoutManagement: React.FC = () => {
  return (
    <Box>
      <PayoutManagement />
    </Box>
  );
};

export default AdminPayoutManagement;
